angular.module('tf.directives')

    .directive("fullscreenLoader",[function(){
        return {
            restrict: "E",
            replace:true,
            template:'' +
                '<div class="ff-loader" ng-class="{\'overlay\' : loader.overlay, \'no-overlay\' : !loader.overlay}" ng-if="loader.loading">\n' +
                '    <div class="logo-center">\n' +
                '        <div class="logo-loader"></div>\n' +
                '    </div>\n' +
                '</div>',
            // templateUrl: "js/components/fullscreenLoader/fullscreenLoader.html",
            link: function(scope){

            }
        };

    }])

;